import { Press } from 'components/press';
const PressContainer = Press;
export { PressContainer };
